module.exports = __webpack_public_path__ + "static/media/view subject.4c99d2fc.svg";